<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row table-responsive" style="margin: 0 !important">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="150px"
        >
          <el-form-item
            label="User Name"
            prop="userName"
            class="form-item-wrap"
          >
            <el-input class="form-input" v-model="formData.userName"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email" class="form-item-wrap">
            <el-input class="form-input" v-model="formData.email"></el-input>
          </el-form-item>
          <el-form-item label="Status" prop="status" class="form-item-wrap">
            <el-select class="form-input-small" v-model="formData.status">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="btn-wrap">
            <el-button type="primary" @click="handleSubmitForm('formData')">{{
              id ? "Save" : "Create"
            }}</el-button>
            <el-button type="defaut" @click="handleCancel">Cancel</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      id: "",
      formData: {
        verificationCode: "",
        userName: "",
        email: "",
        status: "",
        type: 2, //1来自stemup 2来自HSBC 写死就好
        userId: "",
        token: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message: "This field is required",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "This field is required",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "This field is required",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getUserInfo();
    this.loadDetailInfo();
  },
  components: {},
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    statusList() {
      return [
        {
          value: 1,
          label: "Active",
        },
        {
          value: 0,
          label: "Inactive",
        },
      ];
    },
  },
  methods: {
    async loadDetailInfo() {
      if (!this.id) return;
      const params = {
        id: this.id,
        token: this.formData.token,
        userId: this.formData.userId,
      };
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "stemupJudgeUser/hsbcDetail", params);
      if (status_code == "0") {
        this.formData = { ...this.formData, ...result };
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    getUserInfo() {
      const { userId, token } = this.getAuthObj();
      this.formData.userId = userId;
      this.formData.token = token;
    },
    handleSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.id ? this.updateDetail() : this.createDetail();
        } else {
          return false;
        }
      });
    },
    async updateDetail() {
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "stemupJudgeUser/update", {
        ...this.formData,
        id: this.id,
      });
      if (status_code == "0") {
        this.$router.go(-1);
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async createDetail() {
      const {
        data: { status_code, status_message },
      } = await axios.post(
        this.baseURL + "stemupJudgeUser/create",
        this.formData
      );
      if (status_code == "0") {
        this.$router.go(-1);
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handleCancel() {
      this.$router.go(-1);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.btn-wrap {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
}
.form-item-wrap {
  margin-top: 25px;
}
.form-input {
  max-width: 60%;
}
.form-input-medium {
  max-width: 40%;
}
.form-input-small {
  max-width: 30%;
}
</style>
